import { $Qll, $Q } from "../utils/query-selector";
import { fetchMainProduct } from "./product-subscriptions";
import { checkModalCart, fetchModalProduct } from "./modal-cart";

export const initKlaviyoBtn = (query = "") => {
  const klaviyoBtns = $Qll(`${query}.btn-of-stock`);

  if (!klaviyoBtns) return;

  klaviyoBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      let dataHandle = btn.dataset.productHandle;
      let dataTarget = $Q(
        `[data-klaviyo-handle="${dataHandle}"] .klaviyo-bis-trigger`
      );

      if (!dataTarget) return;
      checkModalCart();
      dataTarget.click();
    });
  });
};

/**
 * This function updates the regular and compare prices in main product, modal cart and sticky cart
 * @param {String} query - This is the query for regular or compare price
 * @returns
 */

export const initBundleOptions = (query = "") => {
  const radios = $Qll(`${query}.js-variant-radio`);
  const formInputs = $Qll(`${query}[name="id"]`);

  if (!radios) return;

  radios.forEach((radio) => {
    radio.addEventListener("click", () => {
      const activeOption = $Q(`${query}.jc-variant-option.active`);
      let subscribtionsRadio = $Q(
        `${query}input[name="subscriptions"]:checked`
      );
      let modalActive = $Q(".modal-cart")?.dataset.active;
      let variants = JSON.parse($Q(`${query}#variants`).value);
      let zeroItem = $Q(`${query}.js-variant-radio[value="Abonnement"]`);
      const option1 = activeOption?.dataset.option;
      const option2 = radio.value;

      if (zeroItem && zeroItem.value == option2) {
        option2 = $Q(`${query}.js-variant-radio[value="x1"]`).value;
      }

      if (subscribtionsRadio.value == "subscribe") {
        firstBundlesInput.checked = true;

        if (zeroItem) {
          option2 = "Abonnement";
        } else {
          option2 = $Q(`${query}.js-variant-radio:checked`).value;
        }
      }

      function findProductId(option1, option2) {
        const variant = variants.find(
          (p) => p.option1 === option1 && p.option2 === option2
        );
        return variant ? variant : null;
      }

      const variantObject = findProductId(option1, option2);

      if (formInputs.length > 0) {
        formInputs.forEach((item) => {
          item.value = variantObject.id;
        });
      }

      if (modalActive == "true") {
        let modalCartWindow = $Q(".modal-cart");

        fetchModalProduct(variantObject.id, modalCartWindow, true);
      } else {
        fetchMainProduct(variantObject.id, false, true);
      }

      let featuredMedia = variantObject?.featured_media?.id;
      if (!featuredMedia) return;

      let toggleSliderItem = $Q(`${query}[data-media-id="${featuredMedia}"]`);
      let allMediaItems = $Qll(`${query}[data-media-id]`);
      let slideIndex = parseInt(
        Array.prototype.indexOf.call(allMediaItems, toggleSliderItem)
      );

      if (modalActive == "true" && window.mainSwiperModal) {
        window.mainSwiperModal.slideTo(slideIndex);
      }
    });
  });
};

export const initOptionsToggle = () => {
  document.addEventListener(
    "click",
    (event) => {
      let targetElement = event.target;

      while (targetElement != null) {
        if (targetElement.matches(".jc-variant-option")) {
          event.preventDefault();

          let option = targetElement;
          let optionParent =
            option.closest(".product-card") ||
            option.closest(".main-product") ||
            option.closest(".main-product-page");
          let options = Array.from(
            optionParent.querySelectorAll(".jc-variant-option")
          );
          let inputs = $Qll(
            `#main-product__detail .add-product-cart [name="id"]`
          );
          let index = options.indexOf(targetElement);
          let currentVariant = option.dataset.variant;
          let currentOption = option.dataset.option;
          let newPrice = option.dataset.price;
          let newCompareAtPrice = option.dataset.comparePrice;
          let modalActive =
            document.querySelector(".modal-cart").dataset.active;
          let variantObjectId = option.dataset.variant;
          let ifBundles = document.querySelectorAll(".js-variant-radio");
          let variants = JSON.parse(document.querySelector("#variants").value);
          let maxQuantity = document.querySelector('#maxQuantity');
          let isMaxLimit = 0;
          let quantityBtn = document.querySelector('.jc-main-product-quantity');
  
          if (quantityBtn) {
           isMaxLimit = quantityBtn.dataset.maxLimit;
           quantityBtn.querySelector('input').value = 1;
          }
          if (isMaxLimit == 'true') {
            if (quantityBtn) {
              quantityBtn.querySelector('input').value = 1;
            }
  
            if (currentOption && maxQuantity) {
              if (currentOption.includes('x10')) {
                maxQuantity.innerHTML = 20;
                quantityBtn.querySelector('input').setAttribute('max', 20)
              } else {
                maxQuantity.innerHTML = 9;
                quantityBtn.querySelector('input').setAttribute('max', 9)
              }
            }
          }

          const subscriptionsFieldset = document.querySelector(
            "#jc-main-product__subscriptions"
          );

          if (option.closest(".product-card")) {
            option
              .closest(".product-card")
              .querySelector(".product-card__head")
              .setAttribute("data-variant", currentVariant);
            const productImages = option
              .closest(".product-card")
              .querySelectorAll('[class^="productcard_image-"]');
            productImages.forEach((image) => {
              image.classList.add("jc-opacity-0");
            });

            let productCard = option.closest(".product-card");
            let imageElement = productCard.querySelector(
              ".productcard_image-" + index
            );

            if (!imageElement) {
              imageElement = productCard.querySelector(".productcard_image-0");
            }

            if (imageElement) {
              imageElement.classList.remove("jc-opacity-0");
            }

            const priceElement = option.closest('.js-product-card')?.querySelector('.product-card__form-price');
            if (priceElement) {
              priceElement.textContent = newPrice;
            }
       
            option
              .closest(".product-card")
              .querySelector(".product-card__form-price").innerHTML = newPrice;
            const comparePriceElement = option
              .closest(".product-card")
              .querySelector(".product-card__form-compare-price");

            if (comparePriceElement) {
              comparePriceElement.innerHTML = newCompareAtPrice;
            }
          }

          options.forEach((opt) => {
            opt.classList.remove("active");
          });

          option.classList.add("active");

          function setVariantId(variantObjectId, modalActive) {
            if (subscriptionsFieldset && ifBundles.length) {
              let zeroItem = $Q(`.js-variant-radio[value="Abonnement"]`);
              let radio = $Q('input[name="subscriptions"]:checked');
              let firstBundlesInput = $Q(`.js-variant-radio`, false);
              let option1 = currentOption;
              let option2 = document.querySelector(
                ".js-variant-radio:checked"
              ).value;

              if (zeroItem && zeroItem.value == option2) {
                option2 = $Q(`.js-variant-radio[value="x1"]`).value;
              }

              if (modalActive == "true") {
                zeroItem = $Q(
                  '.modal-cart .js-variant-radio[value="Abonnement"]'
                );
                variants = JSON.parse($Q(".modal-cart #variants").value);
                radio = $Q('.modal-cart input[name="subscriptions"]:checked');
                firstBundlesInput = $Q(".modal-cart .js-variant-radio");
                option2 = document.querySelector(
                  ".modal-cart .js-variant-radio:checked"
                )?.value;

                if (zeroItem && zeroItem.value == option2) {
                  option2 = $Q(
                    `.modal-cart .js-variant-radio[value="x1"]`
                  ).value;
                }

                inputs = $Qll('.modal-cart [name="id"]');
              }

              if (radio.value == "subscribe") {
                firstBundlesInput.checked = true;

                if (zeroItem) {
                  option2 = "Abonnement";
                } else {
                  option2 = $Q(".js-variant-radio:checked").value;
                }
              }

              function findProductId(option1, option2) {
                const variant = variants.find(
                  (p) => p.option1 === option1 && p.option2 === option2
                );
                return variant ? variant : null;
              }

              let variantObject = findProductId(option1, option2);

              if (variantObject && variantObject.featured_media) {
                variantObjectId = variantObject.id;

                let featuredMedia = "";
                featuredMedia = variantObject.featured_media.id;
                let toggleSliderItem = $Q(`[data-media-id="${featuredMedia}"]`);

                if (!toggleSliderItem) return;

                let photoGrid = $Q("#photoSwipe");

                if (photoGrid && window.innerWidth >= 992) {
                  let itemToMove = photoGrid.querySelector(
                    `[data-media-id="${featuredMedia}"]`
                  );

                  if (itemToMove) {
                    photoGrid.prepend(itemToMove);
                  }
                }

                if (modalActive == "true") {
                  const elements = document.querySelectorAll(
                    ".modal-cart .jc-variant-option"
                  );
                  const activeElement = document.querySelector(
                    ".modal-cart .jc-variant-option.active"
                  );
                  const activeIndex =
                    Array.from(elements).indexOf(activeElement);

                  window.mainSwiperModal.slideTo(index);
                }
              }
            } else {
              function findItemByVariantId(items, currentVariant) {
                return items.find((item) => item.id === Number(currentVariant));
              }

              let variantObject = findItemByVariantId(variants, currentVariant);

              if (
                variantObject &&
                variantObject.featured_media &&
                window.innerWidth > 992
              ) {
                let featuredMedia = variantObject.featured_media.id;
                let photoGrid = $Q("#photoSwipe");
                if (photoGrid && window.innerWidth >= 992) {
                  let itemToMove = photoGrid.querySelector(
                    `[data-media-id="${featuredMedia}"]`
                  );

                  if (itemToMove) {
                    photoGrid.prepend(itemToMove);
                  }
                }
              }

              if (modalActive == "true") {
                window.mainSwiperModal.slideTo(index);
              }
            }

            if (window.innerWidth <= 992) {
              if (document.querySelector('#productMainSlider')) {
                window.MProductSwiper.slideTo(index);
              }
            }

            if (modalActive == "true") {
              window.mainSwiperModal.slideTo(index);
            }

            if (inputs.length > 0) {
              inputs.forEach((item) => {
                item.value = variantObjectId;
              });
            }

            return variantObjectId;
          }

          let selectedVariantId = setVariantId(variantObjectId, modalActive);

          if (modalActive === "false") {
            if (option.closest(".product-card")) return;
            fetchMainProduct(selectedVariantId, false, false);
            
          } else {
            const modalCart = $Q(".modal-cart");
            // const isBundles = $Q('.modal-cart #bundle_options') ? true : false;

            fetchMainProduct(
              selectedVariantId,
              modalActive && modalCart,
              false
            );
          }
        }
        targetElement = targetElement.parentElement;
      }
    },
    false
  );
};
